module.exports = __webpack_public_path__ + "static/media/just-activated.78a726ba.png";